function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.61 5a1 1 0 00-.7.285l-.085.083a.946.946 0 000 1.365l2.37 2.302H2.242a.98.98 0 00-.991.966c0 .533.444.965.991.965h12.955l-2.371 2.302a.947.947 0 000 1.366l.085.083a1.01 1.01 0 001.402 0l4.147-4.033a.947.947 0 000-1.366l-4.147-4.033A1.009 1.009 0 0013.61 5z",
  fill: "#FFF",
  fillRule: "nonzero"
});

function SvgIgArrowinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _ref);
}

export default SvgIgArrowinline;